import { Component } from '@angular/core';
import { MenuMobileService } from '@core/services/menu-mobile.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'icon-hamburguer',
  imports: [CommonModule],
  templateUrl: './icon-hamburguer.component.html',
  styleUrl: './icon-hamburguer.component.scss',
})
export class IconHamburguerComponent {
  isActived$ = this.menuService.status();

  constructor(private menuService: MenuMobileService) {}

  toggleStatus() {
    this.menuService.toggleStatus();
  }
}
